import gql from "graphql-tag";

const REMOVE_PRODUCT = gql`
  mutation removeProduct($productId: ID!) {
    removeProduct(productId: $productId)
  }
`;

export default REMOVE_PRODUCT;
